import axios from "axios"; 

const attendMe2 = axios.create({
  baseURL: "https://esystems.cdl.lk/backend-test/AttendMe2",
});

attendMe2.interceptors.request.use((config) => {
  const token =
    axios.defaults.headers.common["Authorization"] ||
    axios.defaults.headers.common["token"];
  if (token) config.headers["Authorization"] = token;
  return config;
});

const OTNonAllocatedLocService = {
  async getAll(date) {
    try {
      const response = await attendMe2.get(`/OTNonAllocatedLoc/GetOTNonAllocatedLoc?p_date=${date}`);
      console.log("API response:", response.data);
      return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
    } catch (error) {
      console.error("Error fetching purchase orders:", error);
      throw error;
    }
  },
};

export default OTNonAllocatedLocService;
